import { render, staticRenderFns } from "./BaseReservation.vue?vue&type=template&id=0502d94e&scoped=true&"
import script from "./BaseReservation.vue?vue&type=script&lang=js&"
export * from "./BaseReservation.vue?vue&type=script&lang=js&"
import style0 from "./BaseReservation.vue?vue&type=style&index=0&id=0502d94e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0502d94e",
  null
  
)

export default component.exports